export default "__VITE_ASSET__gLkhGPKs__"